var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":_vm.proforma}})])}
var staticRenderFns = []

export { render, staticRenderFns }